import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "htlBlockStatus",
    standalone: false,
})
export class HtlBlockStatusPipe implements PipeTransform {
    constructor(private _translate: TranslateService) {}

    transform(status: number): string {
        let statusName = "HTL.HTLBLOCK.TABLE.";
        switch (status) {
            case 1:
                statusName += "open";
                break;
            case 2:
                statusName += "closed";
                break;
            default:
                statusName += "deleted";
                break;
        }
        return this._translate.instant(statusName);
    }
}
